import React from 'react';

const plans = [
  ['Individual Basic', 'Monthly', '50', '5', '0.10'],
  ['Individual Basic', 'Quarterly', '150', '12', '0.08'],
  ['Individual Basic', 'Half-yearly', '300', '22', '0.07'],
  ['Individual Basic', 'Annual', '600', '42', '0.07'],
  ['Individual Unlimited', 'Monthly', '150', '15', '0.10'],
  ['Individual Unlimited', 'Quarterly', '450', '25', '0.06'],
  ['Individual Unlimited', 'Half-yearly', '900', '40', '0.04'],
  ['Individual Unlimited', 'Annual', '1800', '80', '0.04'],
  ['Family up to 3 Basic', 'Monthly', '110', '10', '0.09'],
  ['Family up to 3 Basic', 'Quarterly', '330', '25', '0.08'],
  ['Family up to 3 Basic', 'Half-yearly', '660', '48', '0.07'],
  ['Family up to 3 Basic', 'Annual', '1320', '75', '0.06'],
  ['Family up to 3 Unlimited', 'Monthly', '330', '25', '0.08'],
  ['Family up to 3 Unlimited', 'Quarterly', '990', '70', '0.07'],
  ['Family up to 3 Unlimited', 'Half-yearly', '1980', '110', '0.06'],
  ['Family up to 3 Unlimited', 'Annual', '3960', '150', '0.04'],
  ['Family up to 6 Basic', 'Monthly', '200', '15', '0.08'],
  ['Family up to 6 Basic', 'Quarterly', '600', '40', '0.07'],
  ['Family up to 6 Basic', 'Half-yearly', '1200', '75', '0.06'],
  ['Family up to 6 Basic', 'Annual', '2400', '140', '0.06'],
  ['Family up to 6 Unlimited', 'Monthly', '600', '40', '0.07'],
  ['Family up to 6 Unlimited', 'Quarterly', '1800', '100', '0.06'],
  ['Family up to 6 Unlimited', 'Half-yearly', '3600', '175', '0.05'],
  ['Family up to 6 Unlimited', 'Annual', '7200', '300', '0.04'],
];

const notes = [
  'Guests receive exactly 3 free previews.',
  'Guests cannot save or download previews.',
  'After 3 previews, registration is required to continue.',
  'Registered users may subscribe or use pay-as-you-go at £0.50 per preview.',
];

export default function AiPlansPage() {
  return (
    <main style={{ background: '#f8fafc', color: '#0f172a', minHeight: '100vh' }}>
      <section
        style={{
          padding: '72px 24px 56px',
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1180px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
          }}
        >
          <p
            style={{
              margin: 0,
              color: '#4f46e5',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              fontSize: '0.9rem',
            }}
          >
            AI plans
          </p>

          <h1 style={{ margin: 0, fontSize: '3rem', lineHeight: 1.08, maxWidth: '12ch' }}>
            Compare HnB preview plans more easily
          </h1>

          <p
            style={{
              margin: 0,
              color: '#475569',
              lineHeight: 1.8,
              fontSize: '1.05rem',
              maxWidth: '75ch',
            }}
          >
            HnB uses the preview as the core AI usage unit. Guests can try the
            experience for free, while registered users can either subscribe to a
            plan or use pay-as-you-go pricing.
          </p>
        </div>
      </section>

      <section style={{ padding: '40px 24px 24px' }}>
        <div
          style={{
            maxWidth: '1180px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '16px',
          }}
        >
          {notes.map((note) => (
            <div
              key={note}
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '16px',
                padding: '18px',
              }}
            >
              <p style={{ margin: 0, color: '#334155', lineHeight: 1.7 }}>{note}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '0 24px 24px' }}>
        <div
          style={{
            maxWidth: '1180px',
            margin: '0 auto',
            background: '#eef2ff',
            color: '#312e81',
            border: '1px solid #c7d2fe',
            borderRadius: '16px',
            padding: '18px 20px',
          }}
        >
          <p style={{ margin: 0, lineHeight: 1.7 }}>
            Pay-as-you-go previews are priced at £0.50 each, so plans become more
            cost-effective for customers who expect regular usage.
          </p>
        </div>
      </section>

      <section style={{ padding: '24px 24px 72px' }}>
        <div
          style={{
            maxWidth: '1180px',
            margin: '0 auto',
            overflowX: 'auto',
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '20px',
          }}
        >
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '860px' }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                <th style={thStyle}>Plan</th>
                <th style={thStyle}>Billing period</th>
                <th style={thStyle}>Total previews</th>
                <th style={thStyle}>Price (£)</th>
                <th style={thStyle}>Approx. cost per preview (£)</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((row) => (
                <tr key={row.join('-')}>
                  {row.map((cell, index) => (
                    <td key={`${row[0]}-${row[1]}-${index}`} style={tdStyle}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}

const thStyle: React.CSSProperties = {
  textAlign: 'left',
  padding: '14px 16px',
  borderBottom: '1px solid #e5e7eb',
  color: '#111827',
  fontSize: '0.95rem',
};

const tdStyle: React.CSSProperties = {
  padding: '14px 16px',
  borderBottom: '1px solid #f1f5f9',
  color: '#475569',
  lineHeight: 1.6,
};